import React from 'react';
import { trackError } from '../../utils/analytics';

const DefaultFallback = ({ resetError }) => (
  <div className="error-boundary">
    <h2>Bir şeyler yanlış gitti</h2>
    <p>Sayfayı yenilemeyi deneyin</p>
    <button onClick={() => window.location.reload()} className="btn btn-primary">
      Sayfayı Yenile
    </button>
  </div>
);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this._key = props.resetKey || 0;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    trackError(error.message, errorInfo.componentStack);
    console.error('Error caught by boundary:', error, errorInfo);

    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false, error: null });
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onReset) {
      this.props.onReset();
    }
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return typeof this.props.fallback === 'function'
          ? this.props.fallback({ error: this.state.error, resetError: this.handleReset })
          : this.props.fallback;
      }

      return <DefaultFallback resetError={this.handleReset} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
